import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getAccessManagerData } from 'services/api/AccessManagerAPI';

export const useGetAccessManager = () => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.accessManager,
        queryFn: () => getAccessManagerData(),
    });

    return {
        accessManagerData: data,
        isAccessManagerLoading: isLoading,
        isAccessManagerFetching: isFetching,
        ...rest,
    };
};
